// extracted by mini-css-extract-plugin
export var chevron = "_ka-3";
export var chevronRotated = "_ka-4";
export var image = "_ka-1";
export var imageContainer = "_ka-0";
export var shippingAddress = "_ka-2";